const setSEO = (favicon?: string | null, title?: string | null, description?: string | null) => {
    if(favicon) {
        const link = document.querySelector("link[rel~='icon']") as HTMLLinkElement;
        if(link) link.href = favicon;
    }
    if(title) {
        const titleElement = document.querySelector("title");
        if (titleElement instanceof HTMLTitleElement) {
            titleElement.textContent = title ?? "";
        }
    }
    if(description) {
        const descriptionElement = document.querySelector("meta[name='description']");
        if (descriptionElement instanceof HTMLMetaElement) {
            descriptionElement.content = description ?? "";
        }
    }
}

export {
    setSEO
}